// tslint:disable:max-line-length

export enum FundraisingLabelEnum {
  CheckoutMessage1 = 'Kod ',
  CheckoutMessage2 = 'TYMEK',
  CheckoutMessage3 = ' aktywny. Po zakupie ubezpieczenia Mubi przekaże 100 zł na wsparcie Tymka Kucharczyka!',
  PayToSupport1 = 'Aby wesprzeć Tymka Kucharczyka, opłać polisę.',
  PayToSupport2 = 'Po zakupie polisy Mubi przekaże 100 zł na jego budżet wyścigowy!',
  Quote1 = '„Dzięki za wsparcie - to naprawdę robi różnicę!',
  Quote2 = 'Ja dam z siebie wszystko, żeby wykorzystać tę szansę i godnie',
  Quote3 = 'reprezentować Polskę na światowych torach.”',
  Signature = 'Tymek Kucharczyk',
  SupportBadge = 'Kupując, wspierasz Tymka!',
  ThankYouNote = 'Dzięki Twojemu zakupowi ',
  ThankYouNoteBold = 'Mubi przekaże 100 zł na budżet wyścigowy Tymka Kucharczyka!',
  WatchButton = 'Poznaj historię Tymka',
}
